var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-card",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "box-card",
        },
        [
          _vm.productDetail
            ? _c(
                "div",
                [
                  _c(
                    "div",
                    { staticClass: "product-header" },
                    [
                      _c("div", { staticClass: "product-title" }, [
                        _vm._v(_vm._s(_vm.productDetail.productName)),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-tag",
                        {
                          staticClass: "status-tag",
                          attrs: {
                            type:
                              _vm.productDetail.status === 1
                                ? "success"
                                : "info",
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.productDetail.status === 1 ? "上架" : "下架"
                              ) +
                              "\n        "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-divider"),
                  _vm._v(" "),
                  _c("div", { staticClass: "detail-content" }, [
                    _c(
                      "div",
                      { staticClass: "detail-left" },
                      [
                        _vm.productDetail.imageList &&
                        _vm.productDetail.imageList.length > 0
                          ? _c(
                              "el-carousel",
                              {
                                attrs: {
                                  height: "240px",
                                  "indicator-position": "outside",
                                  autoplay: false,
                                },
                              },
                              _vm._l(
                                _vm.productDetail.imageList,
                                function (image, index) {
                                  return _c(
                                    "el-carousel-item",
                                    { key: index },
                                    [
                                      _c("el-image", {
                                        staticStyle: {
                                          width: "100%",
                                          height: "100%",
                                        },
                                        attrs: { src: image, fit: "contain" },
                                      }),
                                    ],
                                    1
                                  )
                                }
                              ),
                              1
                            )
                          : _c("div", { staticClass: "no-image-large" }, [
                              _c("i", {
                                staticClass: "el-icon-picture-outline",
                              }),
                              _vm._v(" "),
                              _c("p", [_vm._v("暂无图片")]),
                            ]),
                        _vm._v(" "),
                        _vm.productDetail.tagList &&
                        _vm.productDetail.tagList.length > 0
                          ? _c(
                              "div",
                              { staticClass: "product-tags" },
                              _vm._l(_vm.productDetail.tagList, function (tag) {
                                return _c(
                                  "el-tag",
                                  {
                                    key: tag,
                                    staticClass: "product-tag-item",
                                    attrs: { effect: "plain", type: "primary" },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(tag) +
                                        "\n            "
                                    ),
                                  ]
                                )
                              }),
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "detail-right" }, [
                      _c("div", { staticClass: "info-item" }, [
                        _c("span", { staticClass: "info-label" }, [
                          _vm._v("商品ID："),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "info-value" }, [
                          _vm._v(_vm._s(_vm.productDetail.id)),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-item" }, [
                        _c("span", { staticClass: "info-label" }, [
                          _vm._v("售价："),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "info-value price" }, [
                          _vm._v(
                            "￥" + _vm._s(_vm.productDetail.price || "0.00")
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-item" }, [
                        _c("span", { staticClass: "info-label" }, [
                          _vm._v("原价："),
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "info-value original-price" },
                          [
                            _vm._v(
                              "￥" +
                                _vm._s(
                                  _vm.productDetail.originalPrice || "0.00"
                                )
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-item" }, [
                        _c("span", { staticClass: "info-label" }, [
                          _vm._v("材料费："),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "info-value" }, [
                          _vm._v(
                            "￥" +
                              _vm._s(_vm.productDetail.materialPrice || "0.00")
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-item" }, [
                        _c("span", { staticClass: "info-label" }, [
                          _vm._v("检查费："),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "info-value" }, [
                          _vm._v(
                            "￥" + _vm._s(_vm.productDetail.examPrice || "0.00")
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-item" }, [
                        _c("span", { staticClass: "info-label" }, [
                          _vm._v("供应商："),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "info-value" }, [
                          _vm._v(_vm._s(_vm.productDetail.supplierName || "-")),
                        ]),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm.productDetail.description
                    ? _c(
                        "div",
                        { staticClass: "product-description" },
                        [
                          _c(
                            "el-divider",
                            { attrs: { "content-position": "left" } },
                            [_vm._v("商品描述")]
                          ),
                          _vm._v(" "),
                          _c("div", {
                            domProps: {
                              innerHTML: _vm._s(_vm.productDetail.description),
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            : _c(
                "div",
                { staticClass: "empty-product" },
                [
                  _c("i", { staticClass: "el-icon-goods" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("商品详情不存在或已被删除")]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.goBack } },
                    [_vm._v("返回列表")]
                  ),
                ],
                1
              ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }